<template>
  <div class="flex mb-2 mt-1">
    <label
      class="text-left text-sm font-medium w-36 mt-1 text-gray-700"
    >
      Site Title :
    </label>
    <input
      type="text"
      :defaultValue="title"
      placeholder="Site Title"
      class="flex-grow px-3 py-2 border border-gray-300 custom-focus rounded-md h-8"
      @change="updateSiteTitle($event.target.value)"
    />
  </div>
  <!-- App Query String FIELD -->
  <div class="flex mt-3">
    <label
      class="text-left text-sm font-medium w-36 mt-1 text-gray-700"
    >
      App Query String :
    </label>
    <input
      class="flex-grow px-3 py-2 border border-gray-300 custom-focus rounded-md h-8"
      type="text"
      placeholder="App Query String"
      :defaultValue="mobileQuery"
      @change="updateField('mobileQuery', $event.target.value)"
    />
  </div>

  <div class="flex items-center mt-3">
    <label
      class="text-left text-sm font-medium w-36 mt-1 text-gray-700"
    >
      Full Reload :
    </label>
    <input
      class="text-right w-20 px-3 py-2 border border-gray-300 rounded-md custom-focus h-8"
      type="number"
      :defaultValue="fullReload"
      @change="updateField('fullReload', $event.target.value)"
    />
    <span class="ml-2 text-sm">secs</span>
  </div>
  <div class="flex items-center mt-3">
    <label
      class="text-left text-sm font-medium w-36 mt-1 text-gray-700"
    >
      Ajax Reload :
    </label>
    <input
      class="text-right w-20 px-3 py-2 border border-gray-300 rounded-md custom-focus h-8"
      type="number"
      :defaultValue="ajaxReload"
      @change="updateField('ajaxReload', $event.target.value)"
    />
    <span class="ml-2 text-sm">secs</span>
  </div>

  <!-- Device Support -->
  <div class="flex items-center mt-3">
    <label class="text-left text-sm font-medium w-36 text-gray-700">
      Device Support :
    </label>
    <div class="flex items-center gap-5">
      <label class="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
        <input
          type="checkbox"
          :checked="enableMobile"
          class="custom-checkbox"
          @change="updateField('enableMobile', $event.target.checked)"
        />
        Enable Mobile
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
        <input
          type="checkbox"
          :checked="enableIpad"
          class="custom-checkbox"
          @change="updateField('enableIpad', $event.target.checked)"
        />
        Enable iPad
      </label>
    </div>
  </div>

  <hr class="w-full my-4 mb-1" />

  <div class="flex flex-col mt-4">
    <label class="mb-1 font-medium text-sm text-gray-700">
      Global Variables
    </label>

    <div>
      <div
        v-for="(variable, idx) of globalVariables"
        :key="idx"
        class="flex items-center mt-2"
      >
        <input
          :defaultValue="variable.name"
          type="text"
          placeholder="name"
          class="w-32 ml-1 px-3 py-2 border border-gray-300 rounded-md custom-focus mr-2 h-8"
          @change="
            updateVariableField('name', $event.target.value, idx)
          "
        />
        <input
          :defaultValue="variable.value"
          type="text"
          placeholder="value"
          class="flex-1 px-3 py-2 border border-gray-300 rounded-md custom-focus h-8"
          @change="
            updateVariableField('value', $event.target.value, idx)
          "
        />
        <span
          class="ml-2 cursor-pointer opacity-30 hover:opacity-95"
          @click="removeVariable(idx)"
        >
          <font-awesome-icon icon="minus" />
        </span>
      </div>

      <div class="flex items-center my-2 ml-1">
        <input
          v-model="newVariable.name"
          type="text"
          placeholder="name"
          class="w-32 px-3 py-2 border border-gray-300 rounded-md custom-focus mr-2 h-8"
        />
        <input
          v-model="newVariable.value"
          type="text"
          placeholder="value"
          class="flex-1 px-3 py-2 border border-gray-300 rounded-md custom-focus h-8"
        />
        <span
          class="ml-2 cursor-pointer opacity-30 hover:opacity-95"
          @click="addVariable()"
        >
          <font-awesome-icon icon="plus" />
        </span>
      </div>
    </div>

  </div>
  
</template>
<script>

export default {
  name: "SettingsGeneral",
  emits: ["update"],
  components: {},
  props: {
    title: {
      type: String,
      default: () => "",
    },
    extFiles: {
      type: Array,
      default: () => [],
    },
    fullReload: {
      type: [Number, String],
      default: 0,
    },
    ajaxReload: {
      type: [Number, String],
      default: 0,
    },
    mobileQuery: {
      type: String,
      default: () => "",
    },
    enableMobile: {
      type: Boolean,
      default: false,
    },
    enableIpad: {
      type: Boolean,
      default: false,
    },
    globalVariables: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newVariable: {
        name: "",
        value: "",
      },
    }
  },
  computed: {},
  methods: {
    updateField(field, value) {
      console.log("field, value: ", field, value);
      this.$emit("update", { [field]: value });
    },
    removeVariable(idx) {
      const clone = JSON.parse(JSON.stringify(this.globalVariables));
      clone.splice(idx, 1);
      this.$emit("update", { globalVariables: clone });
    },
    addVariable() {
      this.$emit("update", {
        globalVariables: this.globalVariables.concat({
          name: this.newVariable.name,
          value: this.newVariable.value,
        }),
      });
      this.newVariable = {
        name: "",
        value: "",
      };
    },
    updateVariableField(field, value, idx) {
      const clone = JSON.parse(JSON.stringify(this.globalVariables));
      clone[idx][field] = value;
      this.$emit("update", { globalVariables: clone });
    },
    updateSiteTitle(title) {
      this.$emit("update", { siteTitle: title });
    },
  }
}
</script>
<style scoped>
</style>
